import { useEffect, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { authApi } from '@/api/auth';
import { ApiError, onUnauthorized } from '@/lib/http';
import { useAuthStore } from './auth-store';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const queryClient = useQueryClient();
  const setUser = useAuthStore((s) => s.setUser);
  const reset = useAuthStore((s) => s.reset);

  useEffect(() => {
    let cancelled = false;
    authApi
      .me()
      .then((user) => {
        if (!cancelled) setUser(user);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 401) {
          reset();
        } else {
          reset();
          console.error('Failed to load current user', err);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [setUser, reset]);

  useEffect(() => {
    return onUnauthorized(() => {
      reset();
      queryClient.clear();
    });
  }, [reset, queryClient]);

  return <>{children}</>;
}
